// extracted by mini-css-extract-plugin
export default {"dotMenu":"styles_dotMenu__OEtzn","selector":"styles_selector__0QsUv","options":"styles_options__BqX5i","disabled":"styles_disabled__vTOjb"};